import { render, staticRenderFns } from "./PortalCheckbox.vue?vue&type=template&id=9a048cd4&scoped=true&"
import script from "./PortalCheckbox.vue?vue&type=script&lang=ts&"
export * from "./PortalCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./PortalCheckbox.vue?vue&type=style&index=0&id=9a048cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a048cd4",
  null
  
)

export default component.exports